import React, { useState } from "react";
import { Input } from "@/components/ui/input";
import { Eye, EyeOff } from "lucide-react";

/**
 * PasswordInput — Input with a tap-to-show/hide toggle eye icon.
 * Drop-in replacement for <Input type="password" ...>. Forwards all extra
 * props onto the underlying <Input> so `data-testid`, `minLength`, `required`
 * etc. all work as expected.
 */
export default function PasswordInput({ testId = "password", className = "", ...rest }) {
  const [visible, setVisible] = useState(false);
  return (
    <div className="relative">
      <Input
        {...rest}
        type={visible ? "text" : "password"}
        data-testid={testId}
        className={`bg-[#0B0E14] border-[#2A354B] text-white pr-11 ${className}`}
      />
      <button type="button"
        data-testid={`${testId}-toggle`}
        onClick={() => setVisible(v => !v)}
        aria-label={visible ? "Hide password" : "Show password"}
        aria-pressed={visible}
        className="absolute right-2 top-1/2 -translate-y-1/2 p-1.5 rounded text-[#94A3B8] hover:text-white hover:bg-white/5 transition-colors"
        tabIndex={-1}
      >
        {visible ? <EyeOff className="w-4 h-4"/> : <Eye className="w-4 h-4"/>}
      </button>
    </div>
  );
}
